export default {
  setSearchResults(state, searchResults) {
    state.searchResults = searchResults
  },
  setProviders(state, providers) {
    state.providers = providers
  },
  setProvider(state, provider) {
    state.provider = provider
  },
  setPartners(state, partners) {
    state.partners = partners
  },
  setPartner(state, partner) {
    state.partner = partner
  },
  clearPartner(state) {
    state.partner = null
  },
  setProviderAuth(state, providerAuthInfo) {
    state.providerAuthInfo = providerAuthInfo
  },
  setProviderFeedback(state, userInput) {
    state.providerFeedback = userInput
  },
  clearProviderFeedback(state) {
    state.providerFeedback = null
  },
  setStartEnd(state, { start, end }) {
    state.start = start
    state.end = end
  },
  setSharingLink(state, sharingLink) {
    state.sharingLink = sharingLink
  },
  setLocalProviderList(state, list) {
    state.localProviderList = list
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/provider/mutations.js